import { render, staticRenderFns } from "./teacherForm.vue?vue&type=template&id=b9717ce2&"
import script from "./teacherForm.vue?vue&type=script&lang=js&"
export * from "./teacherForm.vue?vue&type=script&lang=js&"
import style0 from "./teacherForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports